<template>
  <Loading v-if="flagLoading" />
  <div class="relative" ref="menuContainer" v-else>
    <img
      src="/icons/projects/action-dots.svg"
      class="w-5 h-5 pointer-events-auto cursor-pointer"
      @click.stop="toggleMenu"
    />
    <div
      v-if="showMenu"
      class="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded shadow-lg z-10"
    >
      <ul>
        <li
          @click="handleAction('View')"
          class="px-4 py-2 cursor-pointer hover:bg-gray-100"
        >
          View bill detail
        </li>

        <!-- <li
          @click="handleAction('Change')"
          class="px-4 py-2 cursor-pointer hover:bg-gray-100"
        >
          Change status
        </li> -->
        <li
          @click="handleAction('Download')"
          class="px-4 py-2 cursor-pointer hover:bg-gray-100"
        >
          Download PDF
        </li>
        <li
          @click="handleAction('Delete')"
          class="px-4 py-2 cursor-pointer hover:bg-red-400 bg-red-200"
          v-if="selectedType == 'Submitted'"
        >
          Delete bill
        </li>
      </ul>
    </div>
    <ModalViewBill
      v-if="showModaBillView"
      :id_bill="item.id_bill"
      :status="item.status"
      :isOpen="showModaBillView"
      @close="showModaBillView = false"
    />
    <ModalDelete
      v-if="showDeletedModal"
      :from="'bill'"
      :item="item"
      :isOpen="showDeletedModal"
      @close="showDeletedModal = false"
    />
  </div>
</template>
    
    <script>
import { ref, onMounted, onUnmounted, watch, computed } from "vue";
import menuState from "../../../const/taskMenuState";
import ModalViewBill from "./BillDetails.vue";
import ModalDelete from "../DeleteModal.vue";
import { useStore } from "vuex";
import Loading from "@/components/CircularLoader.vue";

export default {
  props: {
    item: Object,
  },
  components: {
    ModalViewBill,
    ModalDelete,
    Loading,
  },
  setup(props) {
    const store = useStore();
    const showMenu = ref(false);
    const showModaBillView = ref(false);
    const menuContainer = ref(null);
    const showDeletedModal = ref(false);
    const selectedType = computed(() => store.getters.selectedType);
    const flagLoading = ref(false);

    const toggleMenu = () => {
      const newMenuState = !showMenu.value;
      menuState.setOpenMenuId(newMenuState ? props.item.id_bill : null);
    };

    const handleAction = (action) => {
      if (action == "View") {
        toggleModalView();
      } else if (action == "Delete") {
        deleteTimesheet();
      } else if (action == "Download") {
        handleDownload();
      }
      showMenu.value = false;
      menuState.setOpenMenuId(null);
    };

    const handleClickOutside = (event) => {
      if (menuContainer.value && !menuContainer.value.contains(event.target)) {
        showMenu.value = false;
        menuState.setOpenMenuId(null);
      }
    };

    const handleDownload = async () => {
      flagLoading.value = true;
      const rsp = await store.dispatch("downloadPdf", {
        id: props.item.id_bill,
        type: "bill",
      });
      if (rsp.ok) {
        flagLoading.value = false;
      } else {
        flagLoading.value = false;
      }
    };
    watch(
      () => menuState.getOpenMenuId(),
      (newId) => {
        showMenu.value = newId === props.item.id_bill;
      }
    );

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener("click", handleClickOutside);
    });

    function toggleModalView() {
      showModaBillView.value = !showModaBillView.value;
    }
    function deleteTimesheet() {
      showDeletedModal.value = !showDeletedModal.value;
    }

    return {
      showMenu,
      toggleMenu,
      handleAction,
      menuContainer,
      showModaBillView,
      showDeletedModal,
      selectedType,
      flagLoading,
    };
  },
};
</script>
    
    <style scoped>
/* Add necessary styles if needed */
</style>
    